// 导入 Excel 的配置模态框组件
import React from 'react';
import { Modal, Form, Select } from 'antd';
import { ColumnTypeMapping } from '../types';

const { Option } = Select;

interface ImportConfigModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  headers: string[];
  mappings: ColumnTypeMapping;
  onTypeChange: (header: string, type: string) => void;
}

export const ImportConfigModal: React.FC<ImportConfigModalProps> = ({
  visible,
  onOk,
  onCancel,
  headers,
  mappings,
  onTypeChange,
}) => {
  return (
    <Modal
      title="配置导入列"
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={600}
      okText="确认导入"
      cancelText="取消"
    >
      <p>请为Excel中的每一列选择对应的数据类型，系统将为您创建新的工作表。</p>
      <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {headers.map((header, index) => (
          <Form.Item key={index} label={header} style={{ display: 'flex' }}>
            <Select
              style={{ width: 200, marginLeft: 10 }}
              value={mappings[header]}
              onChange={(value) => onTypeChange(header, value)}
            >
              <Option value="text">文本</Option>
              <Option value="textArea">多行文本</Option>
              <Option value="number">数字</Option>
              <Option value="date">日期</Option>
            </Select>
          </Form.Item>
        ))}
      </div>
    </Modal>
  );
};